import { render, staticRenderFns } from "./PagedMsgTable.vue?vue&type=template&id=04b76fb2&scoped=true&"
import script from "./PagedMsgTable.vue?vue&type=script&lang=js&"
export * from "./PagedMsgTable.vue?vue&type=script&lang=js&"
import style0 from "./PagedMsgTable.vue?vue&type=style&index=0&id=04b76fb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b76fb2",
  null
  
)

export default component.exports